// extracted by mini-css-extract-plugin
module.exports = {"container":"Mo"};